"use strict";

angular.module('PatientApp').factory('Subdomain', ['VuexStore', function (VuexStore) {
  return VuexStore.getters.subdomain;
}]);